import React from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ShellSaac, { useVoltar } from '../../../components/shell/ShellSaac';
import { PageHeader } from '../../../ui';
import StepperAdesao from '../../../components/adesao/StepperAdesao';
import FormularioAssociado, {
  DadosAssociado,
} from '../../../components/associado/FormularioAssociado';

import { updateAssociadoData } from '../../../store/associadoSlice';

import { CARROEDIT } from '../../carro/routes';

/**
 * `/associado/edit` — **etapa 1 da Substituição Veicular** (at-58, frente C).
 *
 * 🔴 **O nome do arquivo mente, e isto vale saber antes de mexer:** apesar do
 * sufixo "Edit", esta não é a tela de "editar associado". É a **primeira etapa de
 * outro fluxo** — a Substituição Veicular —, alcançada pela opção 3 do menu
 * global (`views/home/menuOpcoes.ts`), e daqui se segue para `/carro/edit`.
 * Renomear o arquivo custaria refactor amplo sem o usuário ver diferença
 * (decisão A4 do `plan-c`, mesmo critério da at-54 sobre os identificadores de
 * "bike").
 *
 * ## As diferenças em relação a `/associado`, e só elas
 *
 *   • o "Salvar" leva a `/carro/edit`, não a `/carro`;
 *   • **não grava rascunho** — rascunho é do fluxo de adesão (medido: os 6
 *     chamadores de `salvarEtapaRascunho` estão todos nele);
 *   • tem **"Buscar Associado"**, que carrega quem já é cadastrado no SAAC;
 *   • **não** faz a checagem antecipada de CPF (D3): aqui um CPF que já existe é
 *     exatamente o que se procura — avisar seria ruído em todo uso.
 *
 * Todo o resto — os 19 campos, as máscaras, a validação, o CEP, a regional — vem
 * de `FormularioAssociado`, o mesmo componente das três telas.
 *
 * ⚠️ **Começa vazia, de propósito.** A correção da spec 03 §7.2 (abrir
 * preenchida) vale para a adesão, cujo fluxo é limpo ao começar. As opções de
 * substituição do menu **não** limpam o estado (`menuOpcoes.ts` não marca
 * `limparAdesao` nelas), então pré-preencher aqui mostraria o titular de uma
 * adesão anterior como se fosse o desta substituição. O caminho é o botão
 * "Buscar Associado".
 */
const AssociadoPageEdit: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const voltar = useVoltar();

  const salvar = (dados: DadosAssociado) => {
    dispatch(updateAssociadoData(dados));

    // ⚠️ Sem `setTimeout` (o toast sobrevive à navegação) e sem rascunho.
    navigate(CARROEDIT());
  };

  return (
    <ShellSaac
      cabecalho={
        <PageHeader titulo="Associado" sobretitulo="Substituição Veicular" aoVoltar={voltar} />
      }
    >
      <div className="tw-min-h-full tw-bg-shell">
        <div className="tw-mx-auto tw-w-full tw-max-w-3xl md:tw-p-6">
          <div className="tw-bg-white md:tw-rounded-2xl md:tw-border md:tw-border-superficie-borda md:tw-shadow-[0_2px_12px_rgba(0,0,0,0.09)]">
            <div className="tw-border-b tw-border-superficie-borda">
              <StepperAdesao etapa={1} fluxo={"SUBSTITUICAO_VEICULAR"} />
            </div>

            <div className="tw-p-4 md:tw-p-6">
              <FormularioAssociado
                rotuloAcao="Continuar — Veículo"
                comBuscaLocal
                aoSalvar={salvar}
              />
            </div>
          </div>
        </div>
      </div>
    </ShellSaac>
  );
};

export default AssociadoPageEdit;
